global.jQuery = require('jquery');
var $ = global.jQuery;
window.$ = $;

module.exports = {
  data(){
    return {
      errorMessage: '',
    };
  },
  methods: {
    validate: function () {
      for(var i in this.required_fields){
        let fields = this.required_fields[i].attribute.split('.');
        let parent = this;
        for (var j = 0; j < fields.length ; j++) {
          if(!this.exists(parent, fields[j])){
            this.errorMessage = this.required_fields[i].message;
            $('#' + this.required_fields[i].id).parents('.form--item').addClass('form--item_error');
            $('.content').animate({
              scrollTop: $('.content').offset().top,
            }, 300);
            return false;
          }
          parent = this[fields[j]];
        }

        $('#' + this.required_fields[i].id).parents('.form--item').removeClass('form--item_error');
      }

      this.errorMessage = '';
      this.loadingVisible = true;
      return true;
    },

    exists(parent, field){
      return parent[field];
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/validate-form.mixin.js